import React from 'react';
import DateOutput from "utils/DateOutput";

import { DateExpireProps } from './interface';

import { Container, ContainerDate, Title, BadgeDate, TimeExpire } from './styles';

export const DateExpire: React.FC<DateExpireProps> = (props) => {
  const { title, expiredAt, shouldExpireAt } = props;

  const getRemainingTime = () => {
    const dateNow = new Date();

    const expirationDate = new Date(shouldExpireAt);

    const dateAfter = dateNow > expirationDate ? dateNow : expirationDate;
    const dateBefore = dateNow > expirationDate ? expirationDate : dateNow;

    let seconds = Math.floor((Number(dateAfter) - Number(dateBefore)) / 1000);
    let minutes = Math.floor(seconds / 60);
    let hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);

    hours -= days * 24;
    minutes = minutes - days * 24 * 60 - hours * 60;
    seconds = seconds - days * 24 * 60 * 60 - hours * 60 * 60 - minutes * 60;

    const expired = expiredAt != null;

    const prefixedMessage = expired ? "expirado a " : "irá expirar em ";

    if (days > 0) return `${prefixedMessage + days} dia(s).`;
    if (hours > 0) return `${prefixedMessage + hours} hora(s).`;
    if (minutes > 0) return `${prefixedMessage + minutes} minuto(s).`;
    if (seconds > 0) return `${prefixedMessage + minutes} segundo(s).`;
    return "";
  };

  return (
    <Container>
      <Title>{title}</Title>
      <ContainerDate>
        <BadgeDate expiredAt={expiredAt}>
          <DateOutput
            dateStr={shouldExpireAt}
            patternStr="dd/MM/yyyy"
          />
        </BadgeDate>
        <TimeExpire expiredAt={expiredAt}>
          {getRemainingTime()}
        </TimeExpire>
      </ContainerDate>
    </Container>
  );
};